import type { PaletteMode } from "@mui/material";
import { createContext } from "react";

const ColorModeContext = createContext<{
  changeColorMode: (newMode: PaletteMode) => void;
}>({ changeColorMode: () => {} });

export default ColorModeContext;
